<template>
  <div>
    <div class="filter">
      <el-form
        :inline="true"
        @submit.native.prevent
        :model="filter"
        ref="filterForm"
        label-position="right"
        label-width="80px"
        class="oneline"
        size="small"
      >
        <el-form-item label="上报基地">
          <BaseSelect v-model="filter.base_id" :clearable="true"></BaseSelect>
        </el-form-item>
        <el-form-item label="成品分类">
          <ProductTemplateSelect
            v-model="filter.product_template_id"
            :category="category"
            :clearable="true"
          ></ProductTemplateSelect>
        </el-form-item>
        <el-form-item label="成品编号">
          <ProductSelect
            v-model="filter.product_id"
            :category="category"
            :clearable="true"
          ></ProductSelect>
        </el-form-item>
        <el-form-item label="维修日期" prop="date">
          <el-date-picker
            v-model="filter.date"
            type="daterange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="display: flex; justify-content: end">
      <file-button
        obj="product_repair_data"
        :filter="queryData"
        :importButton="false"
      ></file-button>
    </div>
    <MyTable
      :items="items.list"
      :category="category"
      v-loading="loading"
    ></MyTable>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      @current-change="getData()"
      layout="total, prev, pager, next"
      :total="items.count"
    ></el-pagination>
  </div>
</template>

<script>
import { productStatistics } from '@/service/getData'
import MyTable from './table'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    MyTable,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }

      data.category = this.category
      data.is_data_repaired = true
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        base_id: '',
        product_template_id: '',
        product_id: '',
        date: '',
        page: 1,
        size: 10,
        tab: 'repair_data',
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      const filter = JSON.parse(this.$route.query.filter)
      if (filter.tab == 'repair_data') {
        this.filter = filter
      }
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.base_id = ''
        this.filter.product_template_id = ''
        this.filter.product_id = ''
        this.filter.date = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      this.loading = true
      let res = await productStatistics(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>